import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, ArrowRight } from 'lucide-react';
import { useCart } from '@/lib/CartContext';
import { useAuth } from '@/lib/AuthContext';

/**
 * Mobile-only floating cart bar. Renders as a fixed strip at the bottom of the
 * viewport when a signed-in non-admin buyer has items in their cart and isn't
 * already on the /cart page. Includes safe-area padding for notched devices.
 */
export default function MobileCartBar() {
  const { user } = useAuth();
  const { count, subtotal } = useCart();
  const location = useLocation();

  if (!user || user.role === 'admin') return null;
  if (count === 0) return null;
  if (location.pathname === '/cart') return null;

  return (
    <div
      className="md:hidden fixed left-0 right-0 z-40"
      style={{ bottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="mobile-cart-bar"
    >
      <Link
        to="/cart"
        className="mx-3 mb-3 flex items-center gap-3 px-4 py-3 shadow-[0_18px_36px_-10px_rgba(194,71,138,0.55)] rounded-full"
        style={{
          background: 'linear-gradient(135deg, #F2A6CE 0%, #C2478A 100%)',
          color: '#fff',
        }}
      >
        <span className="relative flex items-center">
          <ShoppingBag size={18} strokeWidth={1.7} />
          <span
            className="absolute -top-1.5 -right-2 sans text-[0.55rem] font-bold rounded-full px-1.5 py-0.5 min-w-[1.15rem] text-center"
            style={{ background: '#0A0A0A', color: '#F2A6CE' }}
          >
            {count > 99 ? '99+' : count}
          </span>
        </span>
        <div className="flex-1 min-w-0">
          <p className="sans text-[0.62rem] tracking-[0.28em] uppercase opacity-90">Your Cart</p>
          <p className="serif text-base leading-tight">${Number(subtotal || 0).toFixed(2)}</p>
        </div>
        <span className="sans text-[0.65rem] tracking-[0.28em] uppercase flex items-center gap-1">
          View <ArrowRight size={14} strokeWidth={1.7} />
        </span>
      </Link>
    </div>
  );
}
